var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 12 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2.65625 11V3H4V11H2.65625ZM5.34375 13.6562V0.34375H6.65625V13.6562H5.34375ZM0 8.34375V5.65625H1.34375V8.34375H0ZM8 11V3H9.34375V11H8ZM10.6562 5.65625H12V8.34375H10.6562V5.65625Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }